import positionManage from "../PositionManage";
import DouYinLink from "../components/douYinLink/DouYinLink";
import BatchAudit from "../components/batch/BatchAudit";
import BatchTransfer from "../components/batch/BatchTransfer";
import BatchAdd from "../components/batch/batchAdd/BatchAdd";
import BatchAssignment from '../components/batch/batchAssignment/BatchAssignment'

export const positionManageRoute = [
    {
        path: "/newMedia/positionManage",
        component: positionManage
    },
    {
        path: "/newMedia/positionManage/batchAudit",
        component: BatchAudit
    },
    {
        path: "/newMedia/positionManage/batchTransfer",
        component: BatchTransfer
    },
    {
        path: "/newMedia/positionManage/batchAdd",
        component: BatchAdd
    },
    {
        path: "/newMedia/positionManage/douYinLink",
        component: DouYinLink
    },
    {
        path: "/newMedia/positionManage/batchAssignment",
        component: BatchAssignment
    },
];